import Component from '../core/Component'
import { disableScrolling, enableScrolling } from '../services/Viewport/scroll'

export const STATUS = {
    OPEN: 'is-open'
}

export default class Nav extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            toggle: null
        }

        this.handleOuterClick = ::this.handleOuterClick
    }

    prepare() {
        this.ref.toggle.addEventListener('click', ::this.handleToggle)
        this.element.addEventListener('click', ::this.handleClick)
    }

    destroy() {
        document.body.removeEventListener('click', this.handleOuterClick)
    }

    handleClick(event) {
        event.stopPropagation()

        if (!this.is(STATUS.OPEN) && event.target === this.element) {
            this.open()
        }
    }

    handleToggle(event) {
        event.preventDefault()
        this.toggle()
    }

    handleOuterClick() {
        this.close()
    }

    toggle() {
        if (this.is(STATUS.OPEN)) {
            this.close()
        } else {
            this.open()
        }
    }

    open() {
        this.element.classList.add(STATUS.OPEN)
        disableScrolling()
        document.body.addEventListener('click', this.handleOuterClick)
    }

    close() {
        this.element.classList.remove(STATUS.OPEN)
        enableScrolling()
        document.body.removeEventListener('click', this.handleOuterClick)
    }

}